import type { ContentPage } from "@/lib/content/types";

export const leadScoring: ContentPage = {
  slug: "process-management/lead-scoring",
  template: "hrmsFeature",
  seo: {
    title: "Lead Scoring Software - Prioritize the Leads Ready to Buy | GetBiz CRM",
    description:
      "Automatically score leads by behaviour and fit with GetBiz CRM lead scoring, so your reps focus on the prospects most likely to convert and close faster.",
    keywords: [
      "lead scoring software",
      "predictive lead scoring",
      "lead prioritization",
      "sales qualification",
      "CRM lead scoring",
      "lead grading",
    ],
    ogImage: "/assets/data/seoimages/lead-scoring.webp",
  },
  leaf: {
    hero: {
      caption: "Lead Scoring",
      title: "Focus on the Leads Most Likely to Convert",
      description:
        "GetBiz CRM scores every lead by behaviour and fit automatically, so your team spends time on the prospects that are ready to buy — not chasing dead ends.",
      h1: "caption",
    },
    split: {
      title: "Know Which Leads Deserve Your Attention",
      bullets: [
        { title: "Behaviour Scoring", description: "Score on opens, clicks, visits and engagement." },
        { title: "Fit Scoring", description: "Weight by industry, size, role and other traits." },
        { title: "Auto-prioritization", description: "Hottest leads rise to the top of every rep's list." },
        { title: "Custom Rules", description: "Tune the model to match your ideal customer." },
      ],
      image: "/assets/images/img/product/crm/lead-scoring-management.webp",
      imageAlt: "GetBiz CRM lead scoring",
    },
    cardsHeading: {
      title: "More Process Management Tools",
      description: "Lead Scoring works with the rest of GetBiz CRM process management.",
    },
    cards: [
      { title: "Assignment Rule", href: "/crm-software/process-management/assignment-rule/", description: "Route your highest-scoring leads to the right rep.", image: "/assets/images/img/product/crm/assignment-rule.webp", imageAlt: "CRM assignment rule" },
      { title: "Sales Blueprint", href: "/crm-software/process-management/sales-blueprint/", description: "Guide scored leads through your winning process.", image: "/assets/images/img/product/crm/sales-blueprint.webp", imageAlt: "CRM sales blueprint" },
      { title: "Approval Process", href: "/crm-software/process-management/approval-process/", description: "Add approvals where high-value leads need sign-off.", image: "/assets/images/img/product/crm/approval-process.webp", imageAlt: "CRM approval process" },
      { title: "Validation Rule", href: "/crm-software/process-management/validation-rule/", description: "Keep lead data clean and complete for accurate scores.", image: "/assets/images/img/product/crm/validation-rule.webp", imageAlt: "CRM validation rule" },
    ],
    testimonials: { title: "Work the right leads first", description: "See why teams score leads in GetBiz CRM." },
    bookDemoTitle: "Put your best leads front and center.",
    relatedBlogs: "slug",
    relatedBlogsKeyword: "lead-scoring-guide, lead-scoring-models-explained",
    metaKey: "lead-scoring",
  },
  sections: [],
};
